import { App, Plugin as VuePlugin } from 'vue'
import { BaseStorage } from '@/utils/webStorage'

const Plugin: VuePlugin = {
  install: (app: App) => {
    app.config.globalProperties.$localStorage = new BaseStorage('local')
    app.config.globalProperties.$sessionStorage = new BaseStorage('session')
  },
}

export default Plugin
